export const move = (array, { fromIndex, toIndex }) => {
  if (
    !Number.isInteger(fromIndex) ||
    !Number.isInteger(toIndex) ||
    fromIndex < 0 ||
    fromIndex >= array.length ||
    toIndex < 0 ||
    fromIndex === toIndex
  ) {
    return array;
  } else if (fromIndex < toIndex) {
    return [
      ...array.slice(0, fromIndex),
      ...array.slice(fromIndex + 1, toIndex),
      array[fromIndex],
      ...array.slice(toIndex),
    ];
  } else {
    return [
      ...array.slice(0, toIndex),
      array[fromIndex],
      ...array.slice(toIndex, fromIndex),
      ...array.slice(fromIndex + 1),
    ];
  }
};

export const isArray = (array) => array != null && Array.isArray(array);

export const hasItems = (array) => isArray(array) && array.length > 0;

export const containsItem = (array, k, v) =>
  hasItems(array) && array.findIndex((x) => (x ?? {})[k] === v) !== -1;
